import { Injectable } from '@angular/core';

import { ConfigProviderService, SearchSectionService } from '@casinocore/platform/core';
import { CookieService, MenuActionsService } from '@frontend/vanilla/core';

@Injectable({
    providedIn: 'root',
})
export class CasinoMenuActionsBootstrapService {
    isSearchOverlayVisible: boolean;
    constructor(
        private menuActions: MenuActionsService,
        private configProviderService: ConfigProviderService,
        private searchSectionService: SearchSectionService,
        private cookie: CookieService,
    ) {}

    onAppInit() {
        if (!this.getFromCookie('dark-mode')) {
            document.getElementsByTagName('html')[0].classList.remove('casino-darkmode');
            this.setBackgroundColor();
        } else {
            document.getElementsByTagName('html')[0].classList.add('casino-darkmode');
        }
        this.menuActions.register('openSearch', () => {
            this.isSearchOverlayVisible = !this.isSearchOverlayVisible;
            this.searchSectionService.setSearchVisibility(this.isSearchOverlayVisible);
        });
    }

    getFromCookie(key: any): boolean {
        if (this.cookie.get(key) > '0') {
            return true;
        }
        return false;
    }

    setBackgroundColor() {
        const global = this.configProviderService.provideGlobalConfig();
        if (global?.lobbyConfigurations?.lobbyBackgroundColor) {
            document.body.style.backgroundColor = global.lobbyConfigurations.lobbyBackgroundColor;
            document.body.setAttribute('data-bg-color', global.lobbyConfigurations.lobbyBackgroundColor);
        }
    }

    setSearchOverlayVisibility(isSearchOverlayVisible: boolean) {
        this.isSearchOverlayVisible = isSearchOverlayVisible;
    }
}
